
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface TestResult {
  id: string;
  test_id: string;
  score: number;
  created_at: string;
  answers: Record<number, { index: number; value?: string }>;
  visual_feedback?: {
    strengths: string[];
    weaknesses: string[];
    recommendations: string[];
  };
  tests: {
    id: string;
    title: string;
    category: string;
    grade_level: string;
    difficulty: 'easy' | 'medium' | 'hard';
  };
}

export const useTestResults = (childId: string) => {
  return useQuery({
    queryKey: ["testResults", childId],
    queryFn: async () => {
      console.log("Fetching test results for child:", childId);
      if (!childId) {
        throw new Error("Child ID is required");
      }

      const { data: results, error: resultsError } = await supabase
        .from("test_results")
        .select(`
          id,
          test_id,
          score,
          created_at,
          answers,
          visual_feedback,
          tests (
            id,
            title,
            category,
            grade_level,
            difficulty
          )
        `)
        .eq("child_id", childId)
        .order("created_at", { ascending: true });

      if (resultsError) {
        console.error("Error fetching test results:", resultsError);
        throw resultsError;
      }

      if (!results) {
        return [];
      }

      console.log("Fetched test results:", results);
      return results as TestResult[];
    },
    enabled: Boolean(childId),
    staleTime: 0, // Always refetch
    gcTime: 0, // Don't keep in cache
  });
};
